module.exports = __webpack_public_path__ + "img/ici_besancon.72fcf1c6.png";